import { s } from '../lib/style.js';

export function Platform({ v }) {
  return (
    <section id="platform" style={s(v.solSection)}>
      {v.solLayoutA ? (
        <>
          <div
            style={s("max-width:1220px;margin:0 auto;padding:clamp(28px,3vw,44px) clamp(20px,4vw,28px) clamp(40px,5vw,64px);")}
          >
            <div
              style={s("display:inline-flex;align-items:center;margin-bottom:18px;padding:9px 20px;border-radius:999px;background:var(--mint);border:1px solid rgba(46,122,114,0.9);box-shadow:0 2px 10px rgba(46,122,114,0.22);font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;letter-spacing:0.14em;text-transform:uppercase;color:#FFFFFF;")}
            >
              The solution
            </div>
            <h2
              style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(32px,4.2vw,54px);line-height:1.06;letter-spacing:-0.03em;margin:0;max-width:840px;color:var(--navy);")}
            >
              Better, faster
              {' '}
              <span style={s(v.kwLight)}>
                decision-making
              </span>
              {' '}
              on one platform
            </h2>
            <p
              style={s("max-width:620px;margin:20px 0 0;font-size:18px;line-height:1.65;color:var(--paper-muted);")}
            >
              Not another dashboard. An interoperable agentic AI foundation that sits beneath the whole team — where the data, the agents, and the teams all connect.
            </p>
            <div style={s("display:flex;flex-direction:column;gap:18px;margin-top:clamp(44px,5vw,68px);")}>
              <div
                className="hv-7"
                style={s("position:relative;overflow:hidden;display:grid;grid-template-columns:repeat(auto-fit,minmax(min(300px,100%),1fr));gap:clamp(28px,4vw,56px);align-items:center;border:1px solid rgba(255,255,255,0.13);border-radius:20px;padding:clamp(28px,3.5vw,44px);box-shadow:0 22px 50px rgba(18,49,56,0.27);transition:transform .4s cubic-bezier(.4,0,.2,1),box-shadow .4s ease;background:radial-gradient(120% 120% at 88% 8%,rgba(91,154,150,0.55),transparent 62%),#0B1F23;")}
              >
                <div
                  aria-hidden="true"
                  style={s("position:absolute;top:0;left:8%;right:8%;height:1px;pointer-events:none;background:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.34) 50%,rgba(255,255,255,0) 100%);")}
                />
                <div
                  aria-hidden="true"
                  style={s("position:absolute;right:-8%;top:-30%;width:52%;height:120%;pointer-events:none;background:radial-gradient(closest-side,rgba(255,255,255,0.20),transparent 72%);")}
                />
                <div style={s("position:relative;")}>
                  <div style={s("display:flex;align-items:baseline;gap:16px;")}>
                    {' '}
                    <span style={s(v.kwNum)}>
                      01
                    </span>
                    {' '}
                    <span
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.16em;text-transform:uppercase;padding:5px 11px;border-radius:999px;background:rgba(255,255,255,0.18);border:1px solid rgba(255,255,255,0.28);color:#DFF3EF;")}
                    >
                      Connect everything
                    </span>
                    {' '}
                  </div>
                  <h3
                    style={s("font-family:'Sofia Pro',sans-serif;font-weight:600;font-size:clamp(24px,2.6vw,34px);letter-spacing:-0.025em;margin:14px 0 0;color:#FFFFFF;")}
                  >
                    Unify
                  </h3>
                  <p style={s("margin:12px 0 0;font-size:18px;line-height:1.6;color:rgba(255,255,255,0.82);")}>
                    The data and tools your team relies on, connected and finally speaking the same language — syndicated, retail, media, and internal, in one governed model.
                  </p>
                </div>
                <div
                  style={s("border:1px solid rgba(255,255,255,0.55);border-radius:14px;overflow:hidden;background:#FFFFFF;box-shadow:0 22px 54px rgba(11,31,35,0.20);")}
                >
                  <div
                    style={s("display:flex;align-items:center;gap:8px;padding:9px 12px;border-bottom:1px solid var(--paper-line);background:#FFFFFF;")}
                  >
                    {' '}
                    <span style={s("width:7px;height:7px;border-radius:50%;background:rgba(11,31,35,0.14);")} />
                    {' '}
                    <span style={s("width:7px;height:7px;border-radius:50%;background:rgba(11,31,35,0.14);")} />
                    {' '}
                    <span style={s("width:7px;height:7px;border-radius:50%;background:rgba(11,31,35,0.14);")} />
                    {' '}
                    <span
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.06em;color:var(--paper-muted);margin-left:6px;")}
                    >
                      Connectors · 54 in catalog
                    </span>
                    {' '}
                  </div>
                  <div
                    style={s("padding:16px;display:flex;flex-direction:column;gap:12px;min-width:0;font-family:'Sofia Pro',sans-serif;background:#FBFAF7;")}
                  >
                    <div
                      style={s("border:1px solid var(--paper-line);border-radius:12px;padding:14px;background:#FFFFFF;display:flex;flex-direction:column;gap:12px;")}
                    >
                      <div style={s("display:flex;align-items:flex-start;gap:11px;")}>
                        {' '}
                        <span
                          style={s("width:30px;height:30px;border-radius:9px;background:#1F3A34;flex:0 0 auto;")}
                        />
                        {' '}
                        <div style={s("font-size:12.5px;line-height:1.5;color:var(--navy);text-wrap:pretty;")}>
                          <strong>
                            The operating system for your AI strategy.
                          </strong>
                          {' '}
                          Every listing runs inside this governed workspace — reads run freely, every write waits for a human.
                        </div>
                      </div>
                      <div
                        style={s("display:flex;flex-wrap:wrap;gap:10px;border-top:1px solid var(--paper-line);padding-top:11px;")}
                      >
                        <div style={s("flex:1;")}>
                          <div style={s("font-size:19px;font-weight:700;color:var(--navy);line-height:1;")}>
                            1
                          </div>
                          <div
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10px;letter-spacing:0.1em;color:var(--paper-muted);margin-top:4px;")}
                          >
                            INSTALLED
                          </div>
                        </div>
                        <div style={s("flex:1;")}>
                          <div style={s("font-size:19px;font-weight:700;color:var(--navy);line-height:1;")}>
                            54
                          </div>
                          <div
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10px;letter-spacing:0.1em;color:var(--paper-muted);margin-top:4px;")}
                          >
                            CATALOG
                          </div>
                        </div>
                        <div style={s("flex:1;")}>
                          <div style={s("font-size:19px;font-weight:700;color:var(--navy);line-height:1;")}>
                            21
                          </div>
                          <div
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10px;letter-spacing:0.1em;color:var(--paper-muted);margin-top:4px;")}
                          >
                            CATEGORIES
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(150px,100%),1fr));gap:10px;")}
                    >
                      <div
                        style={s("border:1px solid var(--paper-line);border-radius:11px;padding:13px;background:#fff;display:flex;flex-direction:column;gap:8px;")}
                      >
                        <div
                          style={s("display:flex;align-items:flex-start;justify-content:space-between;gap:8px;")}
                        >
                          <span
                            style={s("width:28px;height:28px;border-radius:8px;background:#3B8BD0;color:#fff;font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center;flex:0 0 auto;")}
                          >
                            CB
                          </span>
                          <span
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10.5px;color:var(--paper-muted);border:1px solid var(--paper-line);border-radius:5px;padding:2px 6px;")}
                          >
                            Data
                          </span>
                        </div>
                        <div style={s("font-size:13.5px;font-weight:700;color:var(--navy);")}>
                          Snowflake
                        </div>
                        <div
                          style={s("font-size:11.5px;line-height:1.45;color:var(--paper-muted);text-wrap:pretty;")}
                        >
                          Federated over the SQL REST API — a scoped role, no Cortex dependency.
                        </div>
                        <div
                          style={s("display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;min-width:0;margin-top:auto;padding-top:8px;")}
                        >
                          <span
                            style={s("font-size:11px;color:var(--teal);font-weight:600;white-space:nowrap;")}
                          >
                            ● Live
                          </span>
                          <span
                            style={s("font-size:11px;color:var(--navy);font-weight:600;white-space:nowrap;")}
                          >
                            Manage →
                          </span>
                        </div>
                      </div>
                      <div
                        style={s("border:1px solid var(--paper-line);border-radius:11px;padding:13px;background:#fff;display:flex;flex-direction:column;gap:8px;")}
                      >
                        <div
                          style={s("display:flex;align-items:flex-start;justify-content:space-between;gap:8px;")}
                        >
                          <span
                            style={s("width:28px;height:28px;border-radius:8px;background:#111;color:#fff;font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:center;flex:0 0 auto;")}
                          >
                            N
                          </span>
                          <span
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10.5px;color:var(--paper-muted);border:1px solid var(--paper-line);border-radius:5px;padding:2px 6px;")}
                          >
                            Tool
                          </span>
                        </div>
                        <div style={s("font-size:13.5px;font-weight:700;color:var(--navy);")}>
                          Notion
                        </div>
                        <div
                          style={s("font-size:11.5px;line-height:1.45;color:var(--paper-muted);text-wrap:pretty;")}
                        >
                          Connect your workspace with OAuth — no manual page sharing.
                        </div>
                        <div
                          style={s("display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;min-width:0;margin-top:auto;padding-top:8px;")}
                        >
                          <span style={s("font-size:11px;color:var(--paper-muted);")}>
                            ○ Not connected
                          </span>
                          <span
                            style={s("font-size:11px;font-weight:600;color:var(--navy);background:#E9E5DC;border-radius:6px;padding:4px 10px;white-space:nowrap;")}
                          >
                            Connect
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="hv-7"
                style={s("position:relative;overflow:hidden;display:grid;grid-template-columns:repeat(auto-fit,minmax(min(300px,100%),1fr));gap:clamp(28px,4vw,56px);align-items:center;border:1px solid rgba(255,255,255,0.13);border-radius:20px;padding:clamp(28px,3.5vw,44px);box-shadow:0 22px 50px rgba(18,49,56,0.27);transition:transform .4s cubic-bezier(.4,0,.2,1),box-shadow .4s ease;background:radial-gradient(120% 120% at 88% 8%,rgba(46,122,114,0.62),transparent 62%),#0B1F23;")}
              >
                <div
                  aria-hidden="true"
                  style={s("position:absolute;top:0;left:8%;right:8%;height:1px;pointer-events:none;background:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.30) 50%,rgba(255,255,255,0) 100%);")}
                />
                <div
                  aria-hidden="true"
                  style={s("position:absolute;right:-10%;top:-35%;width:56%;height:130%;pointer-events:none;background:radial-gradient(closest-side,rgba(255,255,255,0.20),transparent 70%);")}
                />
                <div style={s("position:relative;")}>
                  <div style={s("display:flex;align-items:baseline;gap:16px;")}>
                    {' '}
                    <span style={s(v.kwNum)}>
                      02
                    </span>
                    {' '}
                    <span
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.16em;text-transform:uppercase;padding:5px 11px;border-radius:999px;background:rgba(255,255,255,0.18);border:1px solid rgba(255,255,255,0.28);color:#E6F5F1;")}
                    >
                      Ask anything
                    </span>
                    {' '}
                  </div>
                  <h3
                    style={s("font-family:'Sofia Pro',sans-serif;font-weight:600;font-size:clamp(24px,2.6vw,34px);letter-spacing:-0.025em;margin:12px 0 0;color:#FFFFFF;")}
                  >
                    Understand
                  </h3>
                  <p style={s("margin:12px 0 0;font-size:18px;line-height:1.6;color:rgba(255,255,255,0.86);")}>
                    Agents that read the whole picture — analyzing performance, surfacing the why, and recommending the next move in a space where the team works together.
                  </p>
                </div>
                <div
                  style={s("border:1px solid rgba(255,255,255,0.55);border-radius:14px;overflow:hidden;background:#FFFFFF;box-shadow:0 22px 54px rgba(11,31,35,0.20);")}
                >
                  <div
                    style={s("display:flex;align-items:center;gap:8px;padding:9px 12px;border-bottom:1px solid var(--paper-line);background:#FFFFFF;")}
                  >
                    {' '}
                    <span style={s("width:7px;height:7px;border-radius:50%;background:rgba(11,31,35,0.14);")} />
                    {' '}
                    <span style={s("width:7px;height:7px;border-radius:50%;background:rgba(11,31,35,0.14);")} />
                    {' '}
                    <span style={s("width:7px;height:7px;border-radius:50%;background:rgba(11,31,35,0.14);")} />
                    {' '}
                    <span
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.06em;color:var(--paper-muted);margin-left:6px;")}
                    >
                      Analyst agent · grounded answer
                    </span>
                    {' '}
                    <span
                      style={s("margin-left:auto;font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.08em;color:var(--mint);")}
                    >
                      GROUNDED
                    </span>
                    {' '}
                  </div>
                  <div
                    style={s("padding:16px;display:flex;flex-direction:column;gap:12px;min-width:0;font-family:'Sofia Pro',sans-serif;background:#FBFAF7;")}
                  >
                    <div
                      style={s("align-self:flex-end;background:var(--navy);border:1px solid var(--navy);border-radius:999px;padding:8px 16px;font-size:13px;color:#FFFFFF;")}
                    >
                      What changed since Friday?
                    </div>
                    <div
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.08em;color:var(--paper-muted);")}
                    >
                      ANALYST · LOAD_DATASET_CATALOG, COMPUTE_SERIES, COMPUTE_METRIC
                    </div>
                    <div style={s("font-size:13px;line-height:1.55;color:var(--navy);")}>
                      The most recent complete POS week is
                      {' '}
                      <strong style={s("color:var(--navy);")}>
                        July 11
                      </strong>
                      {' '}
                      — the July 18 week hasn't populated, so week-over-week is July 11 vs. July 4.
                    </div>
                    <div style={s("font-size:13px;font-weight:700;color:var(--navy);")}>
                      Week ending July 11 vs. July 4
                    </div>
                    <div
                      style={s("border:1px solid var(--paper-line);border-radius:10px;overflow:auto hidden;font-size:12.5px;")}
                    >
                      <div
                        style={s("display:grid;grid-template-columns:1.1fr 1fr 1fr 0.8fr;min-width:min(340px,100%);background:#FFFFFF;color:var(--paper-muted);font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.06em;")}
                      >
                        <div style={s("padding:8px 12px;")}>
                          MEASURE
                        </div>
                        <div style={s("padding:8px 12px;")}>
                          JULY 4
                        </div>
                        <div style={s("padding:8px 12px;")}>
                          JULY 11
                        </div>
                        <div style={s("padding:8px 12px;")}>
                          CHANGE
                        </div>
                      </div>
                      <div
                        style={s("display:grid;grid-template-columns:1.1fr 1fr 1fr 0.8fr;min-width:min(340px,100%);border-top:1px solid var(--paper-line);color:var(--navy);")}
                      >
                        <div style={s("padding:9px 12px;")}>
                          Dollars
                        </div>
                        <div style={s("padding:9px 12px;")}>
                          $4.06M
                        </div>
                        <div style={s("padding:9px 12px;")}>
                          $3.78M
                        </div>
                        <div style={s("padding:9px 12px;color:#C0523A;font-weight:600;")}>
                          −6.8%
                        </div>
                      </div>
                      <div
                        style={s("display:grid;grid-template-columns:1.1fr 1fr 1fr 0.8fr;min-width:min(340px,100%);border-top:1px solid var(--paper-line);background:#FBFAF7;color:var(--navy);")}
                      >
                        <div style={s("padding:9px 12px;")}>
                          Units
                        </div>
                        <div style={s("padding:9px 12px;")}>
                          904K
                        </div>
                        <div style={s("padding:9px 12px;")}>
                          827K
                        </div>
                        <div style={s("padding:9px 12px;color:#C0523A;font-weight:600;")}>
                          −8.6%
                        </div>
                      </div>
                      <div
                        style={s("display:grid;grid-template-columns:1.1fr 1fr 1fr 0.8fr;min-width:min(340px,100%);border-top:1px solid var(--paper-line);color:var(--navy);")}
                      >
                        <div style={s("padding:9px 12px;")}>
                          Velocity
                        </div>
                        <div style={s("padding:9px 12px;")}>
                          42.9 u/s/w
                        </div>
                        <div style={s("padding:9px 12px;")}>
                          39.6 u/s/w
                        </div>
                        <div style={s("padding:9px 12px;color:#C0523A;font-weight:600;")}>
                          −7.7%
                        </div>
                      </div>
                      <div
                        style={s("display:grid;grid-template-columns:1.1fr 1fr 1fr 0.8fr;min-width:min(340px,100%);border-top:1px solid var(--paper-line);background:#FBFAF7;color:var(--navy);")}
                      >
                        <div style={s("padding:9px 12px;")}>
                          Dollar share
                        </div>
                        <div style={s("padding:9px 12px;")}>
                          2.50%
                        </div>
                        <div style={s("padding:9px 12px;")}>
                          2.50%
                        </div>
                        <div style={s("padding:9px 12px;color:var(--mint);font-weight:600;")}>
                          Flat
                        </div>
                      </div>
                    </div>
                    <div style={s("font-size:13px;line-height:1.55;color:var(--navy);")}>
                      <strong style={s("color:var(--navy);")}>
                        The short read:
                      </strong>
                      {' '}
                      Sales and velocity pulled back 7–9% week-over-week, but dollar share held flat at 2.50% — a post-holiday normalization off the July 4 week, not lost ground.
                    </div>
                    <div
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;color:var(--paper-muted);border-top:1px solid var(--paper-line);padding-top:11px;")}
                    >
                      Source: Snowflake federated; POS as of 2026-07-20 · Confidence 0.9
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="hv-7"
                style={s("position:relative;overflow:hidden;display:grid;grid-template-columns:repeat(auto-fit,minmax(min(300px,100%),1fr));gap:clamp(28px,4vw,56px);align-items:center;border:1px solid rgba(255,255,255,0.13);border-radius:20px;padding:clamp(28px,3.5vw,44px);box-shadow:0 22px 50px rgba(18,49,56,0.27);transition:transform .4s cubic-bezier(.4,0,.2,1),box-shadow .4s ease;background:radial-gradient(120% 120% at 88% 8%,rgba(122,206,192,0.42),transparent 62%),#0B1F23;")}
              >
                <div
                  aria-hidden="true"
                  style={s("position:absolute;top:0;left:8%;right:8%;height:1px;pointer-events:none;background:linear-gradient(90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,0.26) 50%,rgba(255,255,255,0) 100%);")}
                />
                <div
                  aria-hidden="true"
                  style={s("position:absolute;right:-8%;top:-30%;width:52%;height:120%;pointer-events:none;background:radial-gradient(closest-side,rgba(255,255,255,0.18),transparent 72%);")}
                />
                <div style={s("position:relative;")}>
                  <div style={s("display:flex;align-items:baseline;gap:16px;")}>
                    {' '}
                    <span style={s(v.kwNum)}>
                      03
                    </span>
                    {' '}
                    <span
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.16em;text-transform:uppercase;padding:5px 11px;border-radius:999px;background:rgba(255,255,255,0.16);border:1px solid rgba(255,255,255,0.26);color:#DDF1ED;")}
                    >
                      Ship the output
                    </span>
                    {' '}
                  </div>
                  <h3
                    style={s("font-family:'Sofia Pro',sans-serif;font-weight:600;font-size:clamp(24px,2.6vw,34px);letter-spacing:-0.025em;margin:14px 0 0;color:#FFFFFF;")}
                  >
                    Act
                  </h3>
                  <p style={s("margin:12px 0 0;font-size:18px;line-height:1.6;color:rgba(255,255,255,0.80);")}>
                    Turn the answer into the deck, the review, the plan — drafted, sourced, and ready to share in minutes instead of weeks.
                  </p>
                </div>
                <div
                  style={s("border:1px solid rgba(255,255,255,0.55);border-radius:14px;overflow:hidden;background:#FFFFFF;box-shadow:0 22px 54px rgba(11,31,35,0.20);")}
                >
                  <div
                    style={s("display:flex;align-items:center;gap:8px;padding:9px 12px;border-bottom:1px solid var(--paper-line);background:#FFFFFF;")}
                  >
                    {' '}
                    <span style={s("width:7px;height:7px;border-radius:50%;background:rgba(11,31,35,0.14);")} />
                    {' '}
                    <span style={s("width:7px;height:7px;border-radius:50%;background:rgba(11,31,35,0.14);")} />
                    {' '}
                    <span style={s("width:7px;height:7px;border-radius:50%;background:rgba(11,31,35,0.14);")} />
                    {' '}
                    <span
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.06em;color:var(--paper-muted);margin-left:6px;")}
                    >
                      Weekly business review · generated artifact
                    </span>
                    {' '}
                    <span
                      style={s("margin-left:auto;font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.08em;color:var(--mint);")}
                    >
                      SOURCED
                    </span>
                    {' '}
                  </div>
                  <div
                    style={s("padding:16px;display:flex;flex-direction:column;gap:12px;min-width:0;font-family:'Sofia Pro',sans-serif;background:#FBFAF7;")}
                  >
                    <div>
                      <div
                        style={s("font-size:17px;font-weight:700;color:var(--navy);letter-spacing:-0.02em;")}
                      >
                        Verde Valley WBR — Week Ending 2026-07-11
                      </div>
                      <div
                        style={s("display:flex;align-items:center;gap:10px;margin-top:6px;font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;color:var(--paper-muted);")}
                      >
                        <span>
                          claude-opus-4-6 · generated artifact
                        </span>
                        <span style={s("color:var(--teal);")}>
                          ✓ Steward: 2 corrections
                        </span>
                      </div>
                    </div>
                    <div style={s("font-size:12.5px;line-height:1.55;color:var(--paper-muted);")}>
                      <strong style={s("color:var(--navy);")}>
                        Top opportunity —
                      </strong>
                      {' '}
                      Club grew +6.6% against a down week. The club item is working while food/mass slows — a lever to lean into now.
                    </div>
                    <div
                      style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.12em;color:var(--paper-muted);")}
                    >
                      KEY CLAIMS
                    </div>
                    <div style={s("display:flex;flex-direction:column;gap:9px;min-width:0;")}>
                      <div
                        style={s("border:1px solid var(--paper-line);border-radius:10px;padding:12px 14px;background:#fff;")}
                      >
                        <div
                          style={s("display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;gap:6px 12px;min-width:0;")}
                        >
                          <span style={s("font-size:12.5px;color:var(--navy);")}>
                            Weekly units, week ending 2026-07-11 (−77,489 / −8.6% WoW)
                          </span>
                          <span
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:14px;font-weight:700;color:var(--navy);white-space:nowrap;")}
                          >
                            826,540
                          </span>
                        </div>
                        <div
                          style={s("display:flex;flex-wrap:wrap;gap:6px 16px;min-width:0;margin-top:7px;font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;color:var(--paper-muted);")}
                        >
                          <span>
                            Data confidence
                            {' '}
                            <span style={s("color:var(--teal);")}>
                              90%
                            </span>
                          </span>
                          <span>
                            Diagnostic strength
                            {' '}
                            <span style={s("color:var(--teal);")}>
                              100%
                            </span>
                          </span>
                        </div>
                      </div>
                      <div
                        style={s("border:1px solid var(--paper-line);border-radius:10px;padding:12px 14px;background:#fff;")}
                      >
                        <div
                          style={s("display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;gap:6px 12px;min-width:0;")}
                        >
                          <span style={s("font-size:12.5px;color:var(--navy);")}>
                            Weekly dollars, week ending 2026-07-11 (−$275,742 / −6.8% WoW)
                          </span>
                          <span
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:14px;font-weight:700;color:var(--navy);white-space:nowrap;")}
                          >
                            $3,780,641
                          </span>
                        </div>
                        <div
                          style={s("margin-top:7px;font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;color:var(--paper-muted);")}
                        >
                          Data confidence
                          {' '}
                          <span style={s("color:var(--teal);")}>
                            90%
                          </span>
                          {' '}
                          · compute_metric (dollars, Verde Valley)
                        </div>
                      </div>
                      <div
                        style={s("border:1px solid var(--paper-line);border-radius:10px;padding:12px 14px;background:#fff;")}
                      >
                        <div
                          style={s("display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;gap:6px 12px;min-width:0;")}
                        >
                          <span style={s("font-size:12.5px;color:var(--navy);")}>
                            Velocity (units/store/week), −7.7% WoW
                          </span>
                          <span
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:14px;font-weight:700;color:var(--navy);white-space:nowrap;")}
                          >
                            39.6 (from 42.9)
                          </span>
                        </div>
                        <div
                          style={s("margin-top:7px;font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;color:var(--paper-muted);")}
                        >
                          Data confidence
                          {' '}
                          <span style={s("color:var(--teal);")}>
                            90%
                          </span>
                          {' '}
                          · compute_series (velocity, Verde Valley)
                        </div>
                      </div>
                    </div>
                    <div style={s("display:flex;flex-wrap:wrap;gap:8px;min-width:0;padding-top:2px;")}>
                      {' '}
                      <span
                        style={s("font-size:11.5px;font-weight:600;color:var(--navy);border:1px solid var(--paper-line);border-radius:7px;padding:6px 12px;background:#fff;")}
                      >
                        ✓ Accept
                      </span>
                      {' '}
                      <span
                        style={s("font-size:11.5px;color:var(--paper-muted);border:1px solid var(--paper-line);border-radius:7px;padding:6px 12px;background:#fff;")}
                      >
                        ✕ Reject
                      </span>
                      {' '}
                      <span
                        style={s("font-size:11.5px;color:var(--paper-muted);border:1px solid var(--paper-line);border-radius:7px;padding:6px 12px;background:#fff;")}
                      >
                        Edited
                      </span>
                      {' '}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
      {v.solLayoutB ? (
        <>
          <div style={s("position:relative;overflow:hidden;")}>
            <div
              aria-hidden="true"
              style={s("position:absolute;inset:0;pointer-events:none;background:radial-gradient(110% 80% at 12% 0%,rgba(46,122,114,0.26),transparent 62%),radial-gradient(90% 70% at 92% 96%,rgba(91,154,150,0.18),transparent 64%);")}
            />
            <div
              style={s("position:relative;z-index:1;max-width:1220px;margin:0 auto;padding:clamp(28px,3vw,44px) clamp(20px,4vw,28px) clamp(40px,5vw,64px);")}
            >
              <div
                style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(320px,100%),1fr));gap:clamp(30px,4vw,64px);align-items:start;")}
              >
                <div>
                  <div
                    style={s("display:inline-flex;align-items:center;margin-bottom:20px;padding:9px 20px;border-radius:999px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.18);font-family:var(--mono);font-weight:var(--mono-w);font-size:13.5px;letter-spacing:0.14em;text-transform:uppercase;color:#7ACEC0;")}
                  >
                    The solution
                  </div>
                  <h2
                    style={s("font-family:'Sofia Pro',sans-serif;font-weight:500;font-size:clamp(32px,4.2vw,54px);line-height:1.06;letter-spacing:-0.03em;margin:0;color:#FFFFFF;text-wrap:pretty;")}
                  >
                    Better, faster
                    {' '}
                    <span style={s(v.kwDark)}>
                      decision-making
                    </span>
                    <br />
                    on one platform
                  </h2>
                </div>
                <p
                  style={s("margin:0;padding-top:clamp(8px,2vw,58px);font-size:18px;line-height:1.7;color:rgba(234,243,241,0.6);max-width:460px;text-wrap:pretty;")}
                >
                  Not another dashboard. An interoperable agentic AI foundation that sits beneath the whole team — where the data, the agents, and the teams all connect.
                </p>
              </div>
              <div style={s("margin-top:clamp(24px,3vw,40px);")}>
                <div
                  style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(320px,100%),1fr));gap:clamp(30px,4vw,64px);align-items:start;padding:clamp(36px,4vw,54px) 0;")}
                >
                  <div>
                    <div style={s(v.kwNum)}>
                      01
                    </div>
                    <h3
                      style={s("font-family:'Sofia Pro',sans-serif;font-weight:600;font-size:clamp(26px,2.7vw,36px);letter-spacing:-0.028em;margin:14px 0 0;color:#FFFFFF;")}
                    >
                      Unify
                    </h3>
                    <div style={s("display:flex;gap:22px;margin-top:22px;")}>
                      <div
                        aria-hidden="true"
                        style={s("flex:0 0 2px;border-radius:2px;background:linear-gradient(180deg,#7ACEC0 0%,#2E7A72 55%,rgba(46,122,114,0) 100%);")}
                      />
                      <div>
                        <p
                          style={s("margin:0;font-size:17px;line-height:1.68;color:rgba(234,243,241,0.68);max-width:440px;text-wrap:pretty;")}
                        >
                          The data and tools your team relies on, connected and finally speaking the same language — syndicated, retail, media, and internal, in one governed model.
                        </p>
                        <div
                          style={s("display:flex;flex-direction:column;gap:9px;min-width:0;margin-top:20px;")}
                        >
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              54-connector catalog
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Syndicated, retail & media data
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              One governed semantic model
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              MCP-ready for your own agents
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Reads run free, writes wait for a human
                            </span>
                            {' '}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={s("border:1px solid rgba(255,255,255,0.11);border-radius:18px;background:linear-gradient(150deg,rgba(255,255,255,0.055) 0%,rgba(255,255,255,0.015) 100%);padding:20px;box-shadow:0 24px 60px rgba(0,0,0,0.32);")}
                  >
                    <div
                      style={s("display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px 10px;min-width:0;padding-bottom:14px;border-bottom:1px solid rgba(255,255,255,0.1);")}
                    >
                      {' '}
                      <span
                        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.1em;text-transform:uppercase;color:rgba(234,243,241,0.5);")}
                      >
                        Connectors
                      </span>
                      {' '}
                      <span
                        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;color:#7ACEC0;")}
                      >
                        54 in catalog
                      </span>
                      {' '}
                    </div>
                    <div
                      style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(140px,100%),1fr));gap:10px;margin-top:14px;")}
                    >
                      <div
                        style={s("border:1px solid rgba(255,255,255,0.1);border-radius:12px;padding:13px;background:rgba(255,255,255,0.03);")}
                      >
                        <div
                          style={s("display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;min-width:0;")}
                        >
                          <span
                            style={s("width:26px;height:26px;border-radius:8px;background:#3B8BD0;color:#fff;font-size:9.5px;font-weight:700;display:flex;align-items:center;justify-content:center;")}
                          >
                            SN
                          </span>
                          <span
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10.5px;color:rgba(234,243,241,0.5);")}
                          >
                            Data
                          </span>
                        </div>
                        <div style={s("margin-top:11px;font-size:13px;font-weight:700;color:#FFFFFF;")}>
                          Snowflake
                        </div>
                        <div style={s("margin-top:7px;font-size:11px;color:#7ACEC0;")}>
                          ● Live
                        </div>
                      </div>
                      <div
                        style={s("border:1px solid rgba(255,255,255,0.1);border-radius:12px;padding:13px;background:rgba(255,255,255,0.03);")}
                      >
                        <div
                          style={s("display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;min-width:0;")}
                        >
                          <span
                            style={s("width:26px;height:26px;border-radius:8px;background:#F4F7F5;color:#0B1F23;font-size:11px;font-weight:700;display:flex;align-items:center;justify-content:center;")}
                          >
                            N
                          </span>
                          <span
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10.5px;color:rgba(234,243,241,0.5);")}
                          >
                            Tool
                          </span>
                        </div>
                        <div style={s("margin-top:11px;font-size:13px;font-weight:700;color:#FFFFFF;")}>
                          Notion
                        </div>
                        <div style={s("margin-top:7px;font-size:11px;color:rgba(234,243,241,0.5);")}>
                          ○ Not connected
                        </div>
                      </div>
                      <div
                        style={s("border:1px solid rgba(255,255,255,0.1);border-radius:12px;padding:13px;background:rgba(255,255,255,0.03);")}
                      >
                        <div
                          style={s("display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;min-width:0;")}
                        >
                          <span
                            style={s("width:26px;height:26px;border-radius:8px;background:#1F3A34;color:#7ACEC0;font-size:9.5px;font-weight:700;display:flex;align-items:center;justify-content:center;")}
                          >
                            NIQ
                          </span>
                          <span
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10.5px;color:rgba(234,243,241,0.5);")}
                          >
                            Syndicated
                          </span>
                        </div>
                        <div style={s("margin-top:11px;font-size:13px;font-weight:700;color:#FFFFFF;")}>
                          NielsenIQ
                        </div>
                        <div style={s("margin-top:7px;font-size:11px;color:#7ACEC0;")}>
                          ● Live
                        </div>
                      </div>
                      <div
                        style={s("border:1px solid rgba(255,255,255,0.1);border-radius:12px;padding:13px;background:rgba(255,255,255,0.03);")}
                      >
                        <div
                          style={s("display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;min-width:0;")}
                        >
                          <span
                            style={s("width:26px;height:26px;border-radius:8px;background:#0A5C9E;color:#fff;font-size:9.5px;font-weight:700;display:flex;align-items:center;justify-content:center;")}
                          >
                            RL
                          </span>
                          <span
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:10.5px;color:rgba(234,243,241,0.5);")}
                          >
                            Retail
                          </span>
                        </div>
                        <div style={s("margin-top:11px;font-size:13px;font-weight:700;color:#FFFFFF;")}>
                          Retail Link
                        </div>
                        <div style={s("margin-top:7px;font-size:11px;color:#7ACEC0;")}>
                          ● Live
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(320px,100%),1fr));gap:clamp(30px,4vw,64px);align-items:start;padding:clamp(36px,4vw,54px) 0;border-top:1px solid rgba(255,255,255,0.09);")}
                >
                  <div>
                    <div style={s(v.kwNum)}>
                      02
                    </div>
                    <h3
                      style={s("font-family:'Sofia Pro',sans-serif;font-weight:600;font-size:clamp(26px,2.7vw,36px);letter-spacing:-0.028em;margin:14px 0 0;color:#FFFFFF;")}
                    >
                      Understand
                    </h3>
                    <div style={s("display:flex;gap:22px;margin-top:22px;")}>
                      <div
                        aria-hidden="true"
                        style={s("flex:0 0 2px;border-radius:2px;background:linear-gradient(180deg,#7ACEC0 0%,#2E7A72 55%,rgba(46,122,114,0) 100%);")}
                      />
                      <div>
                        <p
                          style={s("margin:0;font-size:17px;line-height:1.68;color:rgba(234,243,241,0.68);max-width:440px;text-wrap:pretty;")}
                        >
                          Agents that read the whole picture — analyzing performance, surfacing the why, and recommending the next move in a space where the team works together.
                        </p>
                        <div
                          style={s("display:flex;flex-direction:column;gap:9px;min-width:0;margin-top:20px;")}
                        >
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Grounded, sourced answers
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Week-over-week diagnostics
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Confidence scoring on every claim
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              A shared workspace for the team
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Full tool trace, always inspectable
                            </span>
                            {' '}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={s("border:1px solid rgba(255,255,255,0.11);border-radius:18px;background:linear-gradient(150deg,rgba(255,255,255,0.055) 0%,rgba(255,255,255,0.015) 100%);padding:20px;box-shadow:0 24px 60px rgba(0,0,0,0.32);")}
                  >
                    <div
                      style={s("display:flex;align-items:center;gap:8px;padding-bottom:14px;border-bottom:1px solid rgba(255,255,255,0.1);")}
                    >
                      {' '}
                      <span style={s("width:6px;height:6px;border-radius:50%;background:#7ACEC0;")} />
                      {' '}
                      <span
                        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.1em;text-transform:uppercase;color:#7ACEC0;")}
                      >
                        Analyst agent · grounded answer
                      </span>
                      {' '}
                    </div>
                    <div style={s("margin-top:14px;display:flex;flex-direction:column;gap:12px;")}>
                      <div
                        style={s("align-self:flex-end;background:rgba(255,255,255,0.09);border:1px solid rgba(255,255,255,0.13);border-radius:999px;padding:8px 16px;font-size:13px;color:#EAF3F1;")}
                      >
                        What changed since Friday?
                      </div>
                      <div style={s("font-size:13px;line-height:1.55;color:rgba(234,243,241,0.78);")}>
                        The most recent complete POS week is
                        {' '}
                        <strong style={s("color:#FFFFFF;")}>
                          July 11
                        </strong>
                        {' '}
                        — week-over-week is July 11 vs. July 4.
                      </div>
                      <div
                        style={s("border:1px solid rgba(255,255,255,0.12);border-radius:10px;overflow:auto hidden;font-size:12.5px;")}
                      >
                        <div
                          style={s("display:grid;grid-template-columns:1.1fr 1fr 1fr 0.8fr;min-width:min(340px,100%);background:rgba(255,255,255,0.06);color:rgba(234,243,241,0.62);font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;letter-spacing:0.06em;")}
                        >
                          <div style={s("padding:8px 11px;")}>
                            MEASURE
                          </div>
                          <div style={s("padding:8px 11px;")}>
                            JUL 4
                          </div>
                          <div style={s("padding:8px 11px;")}>
                            JUL 11
                          </div>
                          <div style={s("padding:8px 11px;")}>
                            CHG
                          </div>
                        </div>
                        <div
                          style={s("display:grid;grid-template-columns:1.1fr 1fr 1fr 0.8fr;min-width:min(340px,100%);border-top:1px solid rgba(255,255,255,0.08);color:rgba(234,243,241,0.85);")}
                        >
                          <div style={s("padding:9px 11px;")}>
                            Dollars
                          </div>
                          <div style={s("padding:9px 11px;")}>
                            $4.06M
                          </div>
                          <div style={s("padding:9px 11px;")}>
                            $3.78M
                          </div>
                          <div style={s("padding:9px 11px;color:#FF9E80;font-weight:600;")}>
                            −6.8%
                          </div>
                        </div>
                        <div
                          style={s("display:grid;grid-template-columns:1.1fr 1fr 1fr 0.8fr;min-width:min(340px,100%);border-top:1px solid rgba(255,255,255,0.08);background:rgba(255,255,255,0.03);color:rgba(234,243,241,0.85);")}
                        >
                          <div style={s("padding:9px 11px;")}>
                            Units
                          </div>
                          <div style={s("padding:9px 11px;")}>
                            904K
                          </div>
                          <div style={s("padding:9px 11px;")}>
                            827K
                          </div>
                          <div style={s("padding:9px 11px;color:#FF9E80;font-weight:600;")}>
                            −8.6%
                          </div>
                        </div>
                        <div
                          style={s("display:grid;grid-template-columns:1.1fr 1fr 1fr 0.8fr;min-width:min(340px,100%);border-top:1px solid rgba(255,255,255,0.08);color:rgba(234,243,241,0.85);")}
                        >
                          <div style={s("padding:9px 11px;")}>
                            Dollar share
                          </div>
                          <div style={s("padding:9px 11px;")}>
                            2.50%
                          </div>
                          <div style={s("padding:9px 11px;")}>
                            2.50%
                          </div>
                          <div style={s("padding:9px 11px;color:#7ACEC0;font-weight:600;")}>
                            Flat
                          </div>
                        </div>
                      </div>
                      <div
                        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;color:rgba(234,243,241,0.62);")}
                      >
                        Source: Snowflake federated · Confidence 0.9
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={s("display:grid;grid-template-columns:repeat(auto-fit,minmax(min(320px,100%),1fr));gap:clamp(30px,4vw,64px);align-items:start;padding:clamp(36px,4vw,54px) 0;border-top:1px solid rgba(255,255,255,0.09);")}
                >
                  <div>
                    <div style={s(v.kwNum)}>
                      03
                    </div>
                    <h3
                      style={s("font-family:'Sofia Pro',sans-serif;font-weight:600;font-size:clamp(26px,2.7vw,36px);letter-spacing:-0.028em;margin:14px 0 0;color:#FFFFFF;")}
                    >
                      Act
                    </h3>
                    <div style={s("display:flex;gap:22px;margin-top:22px;")}>
                      <div
                        aria-hidden="true"
                        style={s("flex:0 0 2px;border-radius:2px;background:linear-gradient(180deg,#7ACEC0 0%,#2E7A72 55%,rgba(46,122,114,0) 100%);")}
                      />
                      <div>
                        <p
                          style={s("margin:0;font-size:17px;line-height:1.68;color:rgba(234,243,241,0.68);max-width:440px;text-wrap:pretty;")}
                        >
                          Turn the answer into the deck, the review, the plan — drafted, sourced, and ready to share in minutes instead of weeks.
                        </p>
                        <div
                          style={s("display:flex;flex-direction:column;gap:9px;min-width:0;margin-top:20px;")}
                        >
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Weekly business reviews
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Steward-checked claims
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Deck and doc drafts
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Minutes instead of weeks
                            </span>
                            {' '}
                          </div>
                          <div style={s("display:flex;align-items:baseline;gap:11px;")}>
                            {' '}
                            <span
                              aria-hidden="true"
                              style={s("flex:0 0 auto;width:4px;height:4px;border-radius:50%;background:#5B9A96;transform:translateY(-3px);")}
                            />
                            {' '}
                            <span style={s("font-size:16px;line-height:1.5;color:rgba(234,243,241,0.8);")}>
                              Every number traceable to source
                            </span>
                            {' '}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={s("border:1px solid rgba(255,255,255,0.11);border-radius:18px;background:linear-gradient(150deg,rgba(255,255,255,0.055) 0%,rgba(255,255,255,0.015) 100%);padding:20px;box-shadow:0 24px 60px rgba(0,0,0,0.32);")}
                  >
                    <div
                      style={s("display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px 10px;min-width:0;padding-bottom:14px;border-bottom:1px solid rgba(255,255,255,0.1);")}
                    >
                      {' '}
                      <span
                        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.1em;text-transform:uppercase;color:rgba(234,243,241,0.5);")}
                      >
                        Weekly business review
                      </span>
                      {' '}
                      <span
                        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:11.5px;letter-spacing:0.08em;color:#7ACEC0;")}
                      >
                        SOURCED
                      </span>
                      {' '}
                    </div>
                    <div style={s("margin-top:14px;display:flex;flex-direction:column;gap:12px;")}>
                      <div>
                        <div
                          style={s("font-size:16.5px;font-weight:700;color:#FFFFFF;letter-spacing:-0.02em;")}
                        >
                          Verde Valley WBR — Week Ending 2026-07-11
                        </div>
                        <div
                          style={s("margin-top:6px;font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;color:rgba(234,243,241,0.55);")}
                        >
                          claude-opus-4-6 ·
                          {' '}
                          <span style={s("color:#7ACEC0;")}>
                            ✓ Steward: 2 corrections
                          </span>
                        </div>
                      </div>
                      <div style={s("font-size:12.5px;line-height:1.55;color:rgba(234,243,241,0.75);")}>
                        <strong style={s("color:#FFFFFF;")}>
                          Top opportunity —
                        </strong>
                        {' '}
                        Club grew +6.6% against a down week — a lever to lean into now.
                      </div>
                      <div
                        style={s("border:1px solid rgba(255,255,255,0.12);border-radius:10px;padding:12px 14px;background:rgba(255,255,255,0.03);")}
                      >
                        <div
                          style={s("display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;gap:6px 12px;min-width:0;")}
                        >
                          <span style={s("font-size:12.5px;color:rgba(234,243,241,0.85);")}>
                            Weekly units (−8.6% WoW)
                          </span>
                          <span
                            style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:14px;font-weight:700;color:#FFFFFF;")}
                          >
                            826,540
                          </span>
                        </div>
                        <div
                          style={s("margin-top:7px;font-family:var(--mono);font-weight:var(--mono-w);font-size:11px;color:rgba(234,243,241,0.6);")}
                        >
                          Data confidence
                          {' '}
                          <span style={s("color:#7ACEC0;")}>
                            90%
                          </span>
                          {' '}
                          · diagnostic strength
                          {' '}
                          <span style={s("color:#7ACEC0;")}>
                            100%
                          </span>
                        </div>
                      </div>
                      <div style={s("display:flex;gap:8px;")}>
                        {' '}
                        <span
                          style={s("font-size:11.5px;font-weight:600;color:#0B1F23;background:#7ACEC0;border-radius:7px;padding:6px 12px;")}
                        >
                          ✓ Accept
                        </span>
                        {' '}
                        <span
                          style={s("font-size:11.5px;color:rgba(234,243,241,0.72);border:1px solid rgba(255,255,255,0.16);border-radius:7px;padding:6px 12px;")}
                        >
                          ✕ Reject
                        </span>
                        {' '}
                        <span
                          style={s("font-size:11.5px;color:rgba(234,243,241,0.72);border:1px solid rgba(255,255,255,0.16);border-radius:7px;padding:6px 12px;")}
                        >
                          Edited
                        </span>
                        {' '}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </section>
  );
}
